var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper pd-b-60"},[_c('PersonCover',{attrs:{"data":_vm.personCover}}),_c('HorizontalScrollListRectangular',{attrs:{"data":_vm.appearanceMoviesList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }